'use client';
import './globals.css';

export { GlobalErrorPageSport as default } from '@svenskaspelab/nova-foundation/nextjs/pages';
